import copy from 'copy-to-clipboard';

import { Maybe } from '#/utils/types';

export default function copyToClipboard(text: Maybe<string>) {
  if (text == null) return;
  copy(text, { format: 'text/plain' });
}
